import React from 'react';
import { Field } from 'formik';
import PropTypes from 'prop-types';
import Card, { CardSection } from '@lightspeed/cirrus-card';
import Text from '@lightspeed/cirrus-text';
import { Switch } from '@lightspeed/flame/Switch';

import Skeleton from './Skeleton';

const renderShops = (shops, gatewayConfigId) =>
  shops.map(shop => {
    const isAsssignedToOtherShop =
      shop.gatewayConfigID &&
      shop.gatewayConfigID !== '0' &&
      shop.gatewayConfigID !== gatewayConfigId;

    return (
      <div
        key={`shop_${shop.shopID}`}
        className="cr-flex cr-justify-between cr-items-center cr-pl-3 cr-pr-4 cr-pt-4 cr-pb-4"
      >
        <Text bodySmall bold>
          {shop.name}
        </Text>
        {isAsssignedToOtherShop && (
          <Text bodySmall dimmed>
            The shop is already assigned to another gateway
          </Text>
        )}
        <Field
          name={`shop_${shop.shopID}`}
          render={({ field }) => (
            <Switch
              id={field.name}
              disabled={isAsssignedToOtherShop}
              checked={field.value}
              onChange={field.onChange}
            />
          )}
        />
      </div>
    );
  });

const SelectedShops = ({ isLoading, shops, gatewayConfigId }) => {
  const renderedShops = renderShops(shops, gatewayConfigId);
  return isLoading ? (
    <Skeleton />
  ) : (
    <Card>
      <CardSection noSpacing>{renderedShops}</CardSection>
    </Card>
  );
};

SelectedShops.propTypes = {
  isLoading: PropTypes.bool,
  shops: PropTypes.arrayOf(PropTypes.shape),
  gatewayConfigId: PropTypes.string,
};

SelectedShops.defaultProps = {
  isLoading: true,
  shops: [],
  gatewayConfigId: '',
};

export default SelectedShops;
